// Orchestrator: attempt to auto-close the popped-out PDF tab; fall back to the
// in-app reminder popup when the browser blocks programmatic close or the
// window handle is gone but the session flag still indicates a popout.
//
// See `context/spec/022-pdf-tab-close-reminder/technical-considerations.md`
// §Logic for the exact algorithm.

import * as registry from './pdf-tab-registry'
import { clearPdfTab } from './register-pdf-tab'
import { showReminder } from './reminder-store'
import * as sessionFlag from './session-flag'

export type CloseOrRemindOutcome = 'closed' | 'reminded' | 'noop'

function nextTick(): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, 0))
}

export async function closePdfTabOrRemind(documentKey: string): Promise<CloseOrRemindOutcome> {
  const win = registry.get(documentKey)

  if (win && !win.closed) {
    win.close()
    // Browsers that allow programmatic close flip `.closed` synchronously or
    // on the next tick — yield once so we observe the final state.
    await nextTick()
    if (win.closed) {
      clearPdfTab(documentKey)
      return 'closed'
    }
    showReminder()
    clearPdfTab(documentKey)
    return 'reminded'
  }

  if (sessionFlag.isOpened(documentKey)) {
    showReminder()
    clearPdfTab(documentKey)
    return 'reminded'
  }

  return 'noop'
}
